import React, { useRef, useEffect } from 'react';
import Header from 'modules/Shared/components/Header/Header';
import Footer from 'modules/Shared/components/Footer/Footer';
import Contact from 'modules/MainModule/components/Contact/Contact';
import StartNow from 'modules/Shared/components/StartNow/StartNow';
import { colorBackgroundBrightness } from 'data/common.data';
import '../ProductType.scss';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { insuranceSampleDemo } from 'data/common.data';

const Insurance = (props: any) => {
    useEffect(() => {
        window.scrollTo(0, 0);
    });
    const headerBg: string = '/images/backgrounds/ALEG-Image-Header_TravelInsurance.jpg'
    const styleData = { backgroundImage: `linear-gradient(${colorBackgroundBrightness}, ${colorBackgroundBrightness}), url(${headerBg})`, backgroundPosition: 'center' };
    return (
        <>
            <HelmetProvider>
                <Helmet>
                    <title>AirLegit | Product | Insurance</title>
                    <meta name='description' content='With the help of AirLegit, deliver exceptional customer experiences while reducing operating costs with automation' />
                </Helmet>
            </HelmetProvider>
            <Header />
            <div className='page-min-height product-type-data-container'>
                <div className='header-container container-side-padding container-content-padding' style={styleData}>
                    <div className='container-small-width'>
                        <div className='container no-padding'>
                            <div className='row'>
                                <div className='col-md-6 order-2 order-md-1'>
                                    <div className='product-logo-wrapper'>
                                        <img src='/images/icons/ALEG-ID-Insurance.png' alt='Auto Check-in' />
                                    </div>
                                    <p className='no-margin'>
                                        Not all travel insurance policies offer the same level of coverage. AirLegit's travel insurance is purpose-built for the demands of contemporary travelers.
                                    </p>
                                </div>
                                <div className='col-md-6 order-1 order-md-2'>
                                    <div className='logo-wrapper' style={{ maxWidth: '250px' }}>
                                        <img src='/images/others/ALEG-Image-InsuranceShields.png' alt='airlegit-devices' />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='colored-container container-side-padding container-content-padding'>
                    <div className='container-small-width'>
                        <div className='container no-padding'>
                            <div className='row'>
                                <div className='col-md-12 text-med'>
                                    Travel insurance is there to protect your flights, accommodations, health, belongings and overall trip investment, in case the unexpected happens. With purchasing travel insurance, you can gain peace of mind with 24/7 support and assistance for emergencies and travel tips.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='feature-container container-side-padding container-content-padding'>
                    <div className='container-small-width'>
                        <div className='container no-padding'>
                            <div className='row'>
                                <div className='col-md-4'>
                                    <div className='header-text-main'>
                                        Reasons
                                    </div>
                                    <div className='separator'></div>
                                </div>
                                <div className='col-md-8 order-1 order-md-2 small-screen-padding-top'>
                                    <div className='row'>
                                        <div className='col-md-6'>
                                            <div className='header-text text-l2 text-med'>
                                                TRIP CANCELLATION
                                            </div>
                                            <div className='content-text'>
                                                <p className='no-margin'>
                                                    Unforeseen circumstances that force you to cancel your trip and lose non-refundable deposits or frequent traveler points
                                                </p>
                                            </div>
                                        </div>
                                        <div className='col-md-6 small-screen-padding-top'>
                                            <div className='header-text text-l2 text-med'>
                                                TRAVEL DELAY
                                            </div>
                                            <div className='content-text'>
                                                <p className='no-margin'>
                                                    Unexpected events that require you to return home during your trip.
                                                </p>
                                            </div>
                                        </div>
                                        <div className='col-md-6 small-screen-padding-top large-screen-padding-top'>
                                            <div className='header-text text-l2 text-med'>
                                                BAGGAGE DELAY
                                            </div>
                                            <div className='content-text'>
                                                <p className='no-margin'>
                                                    Purchases you make, like toiletries and clothes, if your baggage is delayed 24 hours or more
                                                </p>
                                            </div>
                                        </div>
                                        <div className='col-md-6 small-screen-padding-top large-screen-padding-top'>
                                            <div className='header-text text-l2 text-med'>
                                                BAGGAGE LOSS OR THEFT
                                            </div>
                                            <div className='content-text'>
                                                <p className='no-margin'>
                                                    Coverage may be available for delayed, stolen or damaged personal items.
                                                </p>
                                            </div>
                                        </div>
                                        <div className='col-md-6 small-screen-padding-top large-screen-padding-top'>
                                            <div className='header-text text-l2 text-med'>
                                                TRIP INTERRUPTION
                                            </div>
                                            <div className='content-text'>
                                                <p className='no-margin'>
                                                    Unexpected events that require you to return home during your trip.
                                                </p>
                                            </div>
                                        </div>
                                        <div className='col-md-6 small-screen-padding-top large-screen-padding-top'>
                                            <div className='header-text text-l2 text-med'>
                                                MEDICAL & DENTAL EMERGENCY ASSISTANCE & TRANSPORTATION
                                            </div>
                                            <div className='content-text'>
                                                <p className=''>
                                                    Coverages are included while you're abroad.
                                                </p>
                                                <p className=''>
                                                    Travel Insurance is offered and produced by Cognitive Junction Inc. T/b/a AirLegit and Cognitive Junction Insurance Agency. Insurance coverages underwritten by Zurich American Insurance Company, a New York domiciled company with its principal place of business at 1299 Zurich Way, Schaumburg, IL 60196 (NAIC # 16535).
                                                </p>
                                                <p className='no-margin'>
                                                    <a href={insuranceSampleDemo} target='_blank' rel='noopener noreferrer' className='text-link'>
                                                        You can view sample of the Travel Protection Plan here.
                                                    </a>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <StartNow />
            </div>
            <Contact />
            <Footer />
        </>
    );
};

export default Insurance;